import { render, staticRenderFns } from "./prelogin.vue?vue&type=template&id=67be5a56&scoped=true"
import script from "./prelogin.vue?vue&type=script&lang=js"
export * from "./prelogin.vue?vue&type=script&lang=js"
import style0 from "./prelogin.vue?vue&type=style&index=0&id=67be5a56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67be5a56",
  null
  
)

export default component.exports